import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ id, value, onChange, testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="hx-pw">
      <input id={id} type={show ? "text" : "password"} className="hx-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} {...props} />
      <button type="button" className="hx-pw__toggle" onClick={() => setShow((s) => !s)} aria-label={show ? "Hide password" : "Show password"} data-testid={`${testId}-toggle`}>
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};
